export const updatelogAdminLittle = log => ({
  type: 'UPDATE_LOG_ADMIN_LITTLE',
  payload: log,
});

export const pushBeforeLogAdminLittle = (log) => ({
  type: "PUSH_BEFORE_LOG_ADMIN_LITTLE",
  payload: log,
});
